
// 获取整个 URL
var url = window.location.href;

// 获取 URL 中的参数部分
var params = window.location.search;
var newUrl  ='';
window.onload=function(){
    console.log(document.getElementById('verfy_div').src)
// 示例用法
    var paramValue = getParamValue('serial');

    var dis = getParamValue('dis');
    if(dis){
        return
    }
    //判断是否有参数

    if(paramValue&&paramValue!=''){
        //修改ifa的src
         newUrl = 'https://looseleafverify.com?sn='+paramValue+'&dis=1';
    }else{
         newUrl = 'https://looseleafverify.com?dis=1';
    }
    document.getElementById('verfy_div').src =newUrl;
};

function getParamValue(param) {
    var query = window.location.search.substr(1);
    var paramArr = query.split('&');
    for (var i = 0; i < paramArr.length; i++) {
        var pair = paramArr[i].split('=');
        if (pair[0] === param) {
            return decodeURIComponent(pair[1]);
        }
    }
    return null;
}
